import { constants, mediaQueryStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { mediaQuery: mq } = mediaQueryStyles;

const utilityNavHeight = 64;

export const utilityNavCss = {
  position: "fixed",
  width: "100%",
  top: 0,
  left: 0,
  height: utilityNavHeight,
  backgroundColor: ui.white[700],
  boxShadow: `0 1px ${ui.neutral[50]}`,
  padding: "0 22px",
};

export const getLayoutCss = (isCard) => ({
  main: {
    backgroundColor: isCard ? ui.core[25] : ui.white[700],
    marginTop: utilityNavHeight,
    overflowX: "hidden",
    overflowY: "auto",
  },
});

export const getMainContentCss = (isCard) => ({
  display: "flex",
  flexDirection: "column",
  padding: "32px 24px 56px",
  ...(isCard
    ? {
        backgroundColor: ui.white[700],
        borderRadius: 16,
        padding: "32px 16px",
        margin: "16px",
        flex: "0 !important",
      }
    : {
        [mq.between(
          constants.breakpoints.BreakpointNames.sm,
          constants.breakpoints.BreakpointNames.md,
        )]: {
          padding: "64px 80px",
        },
        [mq.between(
          constants.breakpoints.BreakpointNames.xs,
          constants.breakpoints.BreakpointNames.sm,
        )]: {
          padding: "40px 32px 48px",
        },
      }),
  [mq.downTo(constants.breakpoints.BreakpointNames.md)]: {
    ...(isCard
      ? {
          maxWidth: 866,
          margin: "40px auto",
          padding: 40,
        }
      : { padding: "88px 80px" }),
  },
});
